import { useState, useEffect } from 'react';
import {useSearchParams, Link, generatePath, createSearchParams, useNavigate} from "react-router-dom";
import {Card, Col, Steps, Typography, Collapse, Divider, Row, Select, Button, message, Spin, Grid, Modal} from "antd";
import { MyButton, MyText } from "../../components";
import { PageName, PlayButtonContainer, StyledUpload, ThemeCollapse, CustomCollapse, LessonPageWrapper, StepIconWrapper, StyledStep, VideoWrapper, LessonSteps, GoalText, ContentText, StyledButton } from './style';
import CardImg from '../../assets/images/pages/Main/game-1.webp';
import { UploadIcon } from '../../assets';
import { PlayIcon, PauseIcon } from '../../assets';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import { ThemeButton,HtmlContentWrapper } from './style';
import { useEmbeddedNavigate } from '../../utils/context/embed';
import {fetchContentByCategoryAction, fetchContentByLessonAction, fetchExportPDFAction, fetchGameCategoriesAction, fetchGamesListAction, ROUTE_PATH, selectStore} from "../../utils";
const isMobile = window.innerWidth < 768;

const { Option } = Select;

const { Step } = Steps;
const { Panel } = Collapse;

const colors = [
    {
        textColor: "#467BA2",
        borderColor: "#6DC1FD",
        backgroundColor: "rgba(109, 193, 253, 0.15)",
    },
    {
        textColor: "#428B56",
        borderColor: "#67D987",
        backgroundColor: "rgba(103, 217, 135, 0.15)",
    },
    {
        textColor: "#A07A1A",
        borderColor: "#FABF29",
        backgroundColor: "rgba(250, 191, 41, 0.15)",
    },
    {
        textColor: "#A35E2B",
        borderColor: "#FF9244",
        backgroundColor: "rgba(255, 146, 68, 0.15)",
    },
    {
        textColor: "#A33232",
        borderColor: "#FF4F4F",
        backgroundColor: "rgba(255, 79, 79, 0.15)",
    },
    {
        textColor: "#624192",
        borderColor: "#9865E3",
        backgroundColor: "rgba(152, 101, 227, 0.15)",
    },

]


export const Games = ({ id }: { id: number }) => {
    const {t} = useTranslation("common")
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const embeddedNavigate = useEmbeddedNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedSubThemeId, setSelectedSubThemeId] = useState(null);
    const [selectedSubThemeName, setSelectedSubThemeName] = useState(null);
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const themeParam = searchParams.get('theme');
    const idParams = searchParams.get('id');
    const parentTheme = searchParams.get('parentTheme');
    const segmentedParams = searchParams.get('type');
    const ageParams = searchParams.get('age');
    const [activeKey, setActiveKey] = useState<string | string[]>([]);
    const [completedSteps, setCompletedSteps] = useState<number[]>([]);
    const [buttonAnimation, setButtonAnimation] = useState<{ [key: number]: boolean }>({});
    const [hideButton, setHideButton] = useState<{ [key: number]: boolean }>({});
    const [openKeys, setOpenKeys] = useState<string[]>([]);
    const [loadingPDF, setLoadingPDF] = useState<{ [key: number]: boolean }>({});

    const contentByLesson = useSelector((state: any) => state.materials?.contentByLesson ?? { data: null, loading: false });
    const [isPlaying, setIsPlaying] = useState<boolean[]>([]);
    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState<any>(null);
    const [selectedParentTheme, setSelectedParentTheme] = useState<any>(null);
    const contentByCategory = useSelector((state: any) => state.materials?.contentByCategory ?? { data: null, loading: false });
    const [themes, setThemes] = useState([]);
    const [lessons, setLessons] = useState<any>([]);
    const [activeKeyTheme, setActiveKeyTheme] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
    const [lessonContent, setLessonContent] = useState({});

    const {materials: {gameCategories: gameCategoriesState}} = useSelector(selectStore)
    const age = searchParams.get("age");
    const isTablet = screens.md && !screens.xl && !screens.xxl;

    let fromAge = "";
    let toAge = "";

    if (age) {
        [fromAge, toAge] = age.split('-');
    }

    useEffect(() => {
        dispatch(fetchGameCategoriesAction({
                fromAge,
                toAge
              }))
    }, []);


    useEffect(() => {
  const handleClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    const wrapper = target.closest('.video-click-wrapper') as HTMLElement;
    if (wrapper?.dataset.videoId) {
      setSelectedVideo(wrapper.dataset.videoId);
      setModalVisible(true);
    }
  };

  document.addEventListener('click', handleClick);
  return () => document.removeEventListener('click', handleClick);
}, []);


async function convertImagesToBase64(container: HTMLElement) {
  const images = container.querySelectorAll("img");

  await Promise.all(
    Array.from(images).map(async (img) => {
      try {
        const res = await fetch(img.src, { cache: "no-store" });
        const blob = await res.blob();
        const base64 = await new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.readAsDataURL(blob);
        });

        img.src = ""; 
        img.src = base64; 
      } catch (e) {
        console.warn("Не удалось загрузить изображение:", img.src);
      }
    })
  );
}

async function waitImagesRealLoad(container: HTMLElement) {
  const images = container.querySelectorAll("img");

  await Promise.all(
    Array.from(images).map((img) => {
      return new Promise<void>((resolve) => {
        if (img.complete && img.naturalWidth > 0) {
          resolve();
        } else {
          img.onload = () => resolve();
          img.onerror = () => resolve();

          const src = img.src;
          img.src = "";
          img.src = src;

          setTimeout(resolve, 1500);
        }
      });
    })
  );
}


// const handleOpenPDF = async (index: number, item: any) => {
//   try {
//     setLoadingPDF(prev => ({ ...prev, [item.id]: true }));

//     const pdfBlob = await fetchExportContent(item.id);

//     const cleanName = item.name
//       .replace(/<br\s*\/?>/gi, '')
//       .replace(/\s+/g, "_")
//       .replace(/[^\wа-яА-ЯёЁ_]/g, "");

//     const fileName = `Задание_${cleanName}.pdf`;

//     const url = window.URL.createObjectURL(pdfBlob);

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();

//     window.URL.revokeObjectURL(url);

//   } catch (e) {
//     console.error("Ошибка PDF:", e);
//   } finally {
//     setLoadingPDF(prev => ({ ...prev, [item.id]: false }));
//   }
// };

const handleOpenPDF = (index: number, item: any) => {
  dispatch(fetchExportPDFAction({ id: item.id, name: item.name }));
};

useEffect(() => {
  if (!contentByLesson.success || !contentByLesson.data) return;

  const { lessonId, content } = contentByLesson.data;
  const firstItem = content?.[0];

  setLessonContent(prev => ({
    ...prev,
    [lessonId]: {
      content: firstItem?.content || "",
      description: firstItem?.description || ""
    }
  }));
}, [contentByLesson.success, contentByLesson.data]);

const handleCollapseChange = (key: string | string[], lessonId: number) => {
  setActiveKey(key);
  toggleIcon(key);

  if (Array.isArray(key)) {
    setOpenKeys(key);
  } else if (key) {
    setOpenKeys([key]);
  } else {
    setOpenKeys([]);
  }

  const isOpened = Array.isArray(key)
    ? key.includes(String(lessonId))
    : String(key) === String(lessonId);

  if (!isOpened) return;

  dispatch(fetchContentByLessonAction({ categoryId: id, id: lessonId }));
};


    const completeStep = (stepIndex: number) => {
  setCompletedSteps(prev => [...prev, stepIndex]);

  setHideButton(prev => ({ ...prev, [stepIndex]: true }));

  setButtonAnimation(prev => ({ ...prev, [stepIndex]: true }));

  const currentKey = String(stepIndex - 1);

  setActiveKey(prev => {
    if (Array.isArray(prev)) {
      return prev.filter(k => k !== currentKey);
    }
    return prev === currentKey ? '' : prev;
  });

  setOpenKeys(prev => prev.filter(k => k !== currentKey));

  setIsPlaying(prev => {
    const updated = [...prev];
    updated[stepIndex - 1] = false;
    return updated;
  });
};

    useEffect(() => {
        if (lessons.length > 0) {
            setIsPlaying(Array(lessons.length).fill(false));
        }
    }, [lessons]);

    const toggleIcon = (index: number) => {
        setIsPlaying((prev) => {
            const updatedPlaying = [...prev];
            updatedPlaying[index] = !updatedPlaying[index];
            return updatedPlaying;
        });
    };

    // useEffect(() => {
    //     const fetchContent = async () => {
    //         if (id) {
    //             try {
    //                 const response = await fetchContentByCategory(id);
    //                 const fetchedThemes = response.themes;
    //                 setThemes(fetchedThemes);
    //                 const parentThemes = fetchedThemes.filter(theme => theme.type === 0 && theme.parent_id == parentTheme);
    //                 const parentThemesButton = fetchedThemes.filter(theme => theme.type === 1 && theme.parent_id == parentTheme);
    //                 const topicId = searchParams.get("topic_id");

    //                 if (topicId) {
    //                     const topicTheme = fetchedThemes.find(theme => theme.id == topicId);
    //                     if (topicTheme) {
    //                         const responseLesson = await fetchContentByCategory(id, topicId);
    //                         setLessons(responseLesson.content);
    //                         setSelectedSubThemeName(topicTheme.name);
    //                         setSelectedSubThemeId(topicTheme.id);
    //                         setActiveKeyTheme(topicTheme.parent_id);

    //                         setSelectedParentTheme(topicTheme);

    //                         return; 
    //                     }
    //                 }
    //                 if (!topicId) {
    //                     const responseLesson = await fetchContentByCategory(id, null);
    //                     setLessons(responseLesson.content);
    //                     setSelectedSubThemeName(t("all"));
    //                     setSelectedSubThemeId(null);
    //                     setSelectedParentTheme({ id: null, name: t("all") });
    //                     setActiveKeyTheme(null);
    //                     return;
    //                 }

    //                 const firstParentId = parentThemes[0]?.id;
    //                 const firstParentButtonId = parentThemesButton[0]?.id;

    //                 const firstType1Theme = fetchedThemes.find(theme => theme.type === 1 && theme.parent_id === firstParentId);
    //                 const firstType1ButtonTheme = fetchedThemes.find(theme => theme.type === 1 && theme.parent_id === firstParentButtonId);
    //                 if (firstType1Theme) {
    //                     const responseLesson = await fetchContentByCategory(id, firstType1Theme.id);
    //                     setLessons(responseLesson.content);
    //                     setSelectedSubThemeName(firstType1Theme.name);
    //                     setSelectedSubThemeId(firstType1Theme.id);
    
    //                     const parentTheme = fetchedThemes.find(theme => theme.id === firstType1Theme.parent_id);
    //                     if (parentTheme) {
    //                         setActiveKeyTheme(parentTheme.id);
    //                     }
    //                 } else {
    //                     const parentThemesButton = fetchedThemes.filter(theme => theme.type === 1 && theme.parent_id == parentTheme);
    //                     const firstParentButtonId = parentThemesButton[0]?.id;
                       
    //                     const firstType1ButtonTheme = parentThemesButton.find(theme => theme.type === 1 && theme.id === firstParentButtonId);


    //                     if (firstType1ButtonTheme) {
    //                         const responseLesson = await fetchContentByCategory(id, firstType1ButtonTheme.id);
    //                         setLessons(responseLesson.content);
    //                         setSelectedSubThemeName(firstType1ButtonTheme.name);
    //                         setSelectedSubThemeId(firstType1ButtonTheme.id);
    //                         setSelectedParentTheme(firstType1ButtonTheme);

    //                         const parentTheme = fetchedThemes.find(theme => theme.id === firstType1ButtonTheme.parent_id);
    //                         if (parentTheme) {
    //                             setActiveKeyTheme(parentTheme.id);
    //                         }
    //                     } else {
    //                         console.warn('No theme with type 1 found');
    //                     }
    //                 }
    //             } catch (error) {
    //                 console.error('Error fetching content:', error);
    //             }
    //         }
    //     };
    
    //     fetchContent();
    // }, [id]);

    useEffect(() => {
        if (!id) return;
        const topicId = searchParams.get("topic_id");
        dispatch(fetchContentByCategoryAction({
            categoryId: id,
            topicId: topicId ? Number(topicId) : undefined,
            loadFirstTheme: !topicId,
        }));
    }, [id]);

    useEffect(() => {
        if (!contentByCategory.success || !contentByCategory.data) return;
        const data = contentByCategory.data;
        setThemes(data.themes || []);

        if (data.topicLessons) {
            setLessons(data.topicLessons);
            setSelectedSubThemeName(data.selectedSubThemeName);
            setSelectedSubThemeId(data.selectedSubThemeId);
            setActiveKeyTheme(data.activeKeyTheme);
            setSelectedParentTheme(data.selectedParentTheme);
            return;
        }

        if (data.firstTheme) {
            setLessons(data.firstThemeLessons || []);
            setSelectedSubThemeName(data.firstTheme.name);
            setSelectedSubThemeId(data.firstTheme.id);
            const parentTheme = data.themes.find((t: any) => t.id === data.firstTheme.parent_id);
            if (parentTheme) setActiveKeyTheme(parentTheme.id);
        }

        if (data.allLessons) {
            setLessons(data.allLessons);
            setSelectedSubThemeName(t("all"));
            setSelectedSubThemeId(null);
            setSelectedParentTheme({ id: null, name: t("all") });
            setActiveKeyTheme(null);
        }
    }, [contentByCategory.success, contentByCategory.data]);

    // const parentThemes = themes.filter(theme => theme.type === 0 && theme.parent_id == parentTheme);
    const parentThemes = themes.filter(theme => theme.type === 0 && theme.parent_id == parentTheme);
    const parentThemesButton = themes.filter(theme => theme.type === 1 && theme.parent_id == parentTheme);

    const handlePanelChange = async (key: string) => {
        setActiveKeyTheme(activeKeyTheme === key ? null : key);
    };


    const handleSelectGameCategory = (gameCategory: any) => {

        const path = {
            pathname: generatePath(ROUTE_PATH.GAMES_LIST, {gameCategory: gameCategory.id}),
            // @ts-ignore
            search: createSearchParams({
               age: ageParams,
               type: segmentedParams,
               selectedMaterial: idParams
            }).toString(),
        }

        embeddedNavigate(path)

    }

   const adaptIframe = (html: string) => {
  if (!html) return '';

  return html
  .replace(
    /(<iframe[^>]*src="https:\/\/www\.youtube\.com\/embed\/([^"?&]+)"[^>]*><\/iframe>)/gi,
    (_match, fullIframe, videoId) => {
      const wrapperTag = 'span';
      const wrapperStyle = screens.xs
        ? 'position:relative;width:100%;aspect-ratio:16/9;cursor:pointer;display:inline-block;'
        : 'position:relative;cursor:pointer;display:inline-block;';

      const iframeWithStyle = screens.xs
        ? fullIframe.replace(
            '<iframe',
            '<iframe style="position:absolute;top:0;left:0;width:100%;height:100%;"'
          )
        : fullIframe;

      return `<${wrapperTag} class="video-click-wrapper" data-video-id="${videoId}" style="${wrapperStyle}">
        <span style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:2;"></span>
        ${iframeWithStyle}
      </${wrapperTag}>`;
    }
  )
  .replace(
    /<p([^>]*)>/gi,
    '<p$1 style="margin-bottom:0.2em;">'
  );
   }

    return (
        <Col span={24}>
            <div style={{ display: 'flex', gap: '32px', justifyContent: 'space-between', flexDirection: isTablet ? 'column' : 'row'}}>
                <Card style={{ width: isMobile || isTablet ? '100%' : '80%', borderRadius: '20px' }}>
                {!isMobile && (
                <Col span={24}>
                            <MyText color='rgba(19, 15, 38, 1)' size={32} weight={800}
                                    style={{fontFamily: 'Nunito', display: 'block', marginBottom: 32}}>
                            {selectedSubThemeName}
                            </MyText>

                            </Col>

                            
                )}
                <LessonPageWrapper style={{padding: '0'}}>
                {/* {isMobile && lessons.length > 0 && (
                        <LessonSteps direction={isMobile ? "vertical" : "horizontal"}  style={{ marginBottom: '16px', flexDirection: 'row' }}>
                        {lessons.map((_, index) => (
                            <StyledStep
                                key={index}
                                status={completedSteps.includes(index + 1) ? 'finish' : 'wait'}
                                icon={<StepIconWrapper completed={completedSteps.includes(index + 1)} />}
                            />
                        ))}
                    </LessonSteps>
                        
                )} */}
                <Row  style={{ width: '100%' }}>
                    {lessons.length > 0 ? (
                        lessons.map((item, index) => (
                            <>
                            <Col span={isMobile ? 3 : isTablet ? 2 : 1}>
                            {/* <LessonSteps direction="vertical">
                                <StyledStep
                                status={completedSteps.includes(index + 1) ? 'finish' : 'wait'}
                                icon={<StepIconWrapper completed={completedSteps.includes(index + 1)} />}
                                />
                            </LessonSteps> */}
                            </Col>
                                <Col span={24}>
                                    <CustomCollapse activeKey={activeKey} onChange={(key) => handleCollapseChange(key, item.id)} style={{ marginBottom: '16px' }}>
                                        <Panel
                                            header={
                                                <>
                                                <Col 
                                                span={24}
                                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Col
                                                    span={screens.xs ? 20 : 22}
                                                    style={{ display: 'flex', gap: '24px', alignItems: screens.xs ? undefined : 'center'}}>
                                                    <Col
                                                    span={screens.xs ? 24 : 2}
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: isMobile ? 'row' : 'column',
                                                        alignItems: isMobile ? 'flex-end' : 'center',
                                                        gap: isMobile ? '5px' : 'initial',
                                                        marginBottom: isMobile ? '12px' : '0',
                                                    }}
                                                    >    
                                                    <MyText color='rgba(71, 74, 87, 1)' size={28} weight={800} style={{ fontFamily: 'Nunito' }}>
                                                                {index + 1}
                                                            </MyText>
                                                            <MyText color='rgba(71, 74, 87, 1)' size={12} weight={700} style={{ fontFamily: 'Nunito', lineHeight: '16px' }}>
                                                            {`${t("lesson")}`}
                                                            </MyText>
                                                        </Col>
                                                        {!isMobile && (
                                                        <Col span={22}>
                                                        <MyText color='rgba(71, 74, 87, 1)' size={18} weight={400} style={{lineHeight: '20px' }}>
                                                              {item.name.replace(/<br\s*\/?>/gi, '')}
                                                        </MyText>
                                                        </Col>
                                                        )}
                                                    </Col>
                                                    <Col span={screens.xs ? 3 : 1}>
                                                    
                                                    {/* <PlayButtonContainer>
                                                    {activeKey.includes(index.toString()) ? (
                                                        <PauseIcon style={{ color: 'rgba(255, 149, 0, 1)' }} />
                                                        ) : (
                                                        <PlayIcon isActive={false} />
                                                        )}
                                                    </PlayButtonContainer> */}
                                                    {completedSteps.includes(index + 1) ? (
                                                        <StepIconWrapper completed={true} />
                                                    ) : (
                                                        <PlayButtonContainer>
                                                            {activeKey.includes(index.toString()) ? (
                                                                <PauseIcon style={{ color: 'rgba(255, 149, 0, 1)' }} />
                                                            ) : (
                                                                <PlayIcon isActive={false} />
                                                            )}
                                                        </PlayButtonContainer>
                                                    )}
                                                </Col>

                                                </Col>
                                                {isMobile && (
                                                    <MyText color='rgba(71, 74, 87, 1)' size={18} weight={400} style={{ lineHeight: '20px' }}>
                                                    {item.name.replace(/<br\s*\/?>/gi, '')}
                                                    </MyText>
                                                )}
                                                </>
                                            }
                                           key={String(item.id)}
                                        >
                                           <div id={`export-content-${index}`}>
                                            {lessonContent[item.id] ? (
                                                <>
                                                    {lessonContent[item.id].description && (
                                                        <HtmlContentWrapper
                                                            screens={screens}
                                                            dangerouslySetInnerHTML={{
                                                                __html: adaptIframe(lessonContent[item.id].description),
                                                            }}
                                                        />
                                                    )}
                                                    {lessonContent[item.id].content && (
                                                        <HtmlContentWrapper
                                                            screens={screens}
                                                            dangerouslySetInnerHTML={{
                                                                __html: adaptIframe(lessonContent[item.id].content),
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            ) : (
                                                <Spin />
                                            )}
                                        </div>

                                             <Modal
                                                open={modalVisible}
                                                onCancel={() => setModalVisible(false)}
                                                footer={null}
                                                width={isMobile ? '100%' : '50%'}
                                                bodyStyle={{ padding: isMobile ? 14 : 30 }}
                                                style={{ top: 70 }}
                                                >
                                                <div style={{ position: 'relative', paddingBottom: isMobile ? '100%' : '56.25%', height: 0 }}>
                                                    <iframe
                                                    title="video"
                                                    src={`https://www.youtube.com/embed/${selectedVideo}`}
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    allowFullScreen
                                                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                    />
                                                </div>
                                                </Modal>
                                            <StyledButton
                                                type="primary"
                                                onClick={() => {
                                                    completeStep(index + 1);
                                                    handleCollapseChange([], item.id);
                                                }}
                                                animate={buttonAnimation[index + 1]}
                                                style={{ display: hideButton[index + 1] ? 'none' : 'inline-block', marginTop: '8px', marginRight: '15px',  width: isTablet || screens.xs ? '100%' : 'auto', }}
                                            >
                                                {`${t("completeTask")}`}
                                            </StyledButton>

                                            <StyledButton
                                                type="secondary"
                                                disabled={loadingPDF[item.id]}
                                                onClick={() => handleOpenPDF(index, item)}
                                                animate={buttonAnimation[index + 1]}
                                                style={{ display: hideButton[index + 1] ? 'none' : 'inline-block', marginTop: '8px',  width: isTablet || screens.xs ? '100%' : 'auto', minWidth: 160,}}
                                            >
                                                {loadingPDF[item.id] ? (
                                                    <Spin size="small" style={{ color: 'white' }}/>
                                                ) : (
                                                    t("downloadTask")
                                                )}
                                            </StyledButton>
                                        </Panel>
                                    </CustomCollapse>
                                </Col>
                            </>
                        ))
                    ) : (
                        <Col>
                            <Spin/>
                        </Col>
                    )}
                </Row>
            </LessonPageWrapper>
                            </Card>

                            {!isMobile && (
                            <Card style={{ width: isTablet ? '100%' : '25%', borderRadius: '20px' }}>
            <PageName>
                <MyText color="#0A033C" size={18} weight={800} style={{ marginBottom: '16px', fontFamily: 'Nunito' }}>
                  {t("topics")}
                    </MyText>
                    <ThemeButton
                        key="all"
                        // onClick={async () => {
                        // setSelectedSubThemeId(null);
                        // setSelectedSubThemeName(t("all"));
                        // setActiveKeyTheme(null);
                        // setSelectedParentTheme({ id: null, name: t("all") });
                        // setSearchParams(prevParams => {
                        //     prevParams.set('topic_id', '');
                        //     return prevParams;
                        // });
                        // try {
                        //     const response = await fetchContentByCategory(id, null);
                        //     setThemes(response.themes);
                        //     setLessons(response.content);
                        // } catch (error) {
                        //     console.error('Error fetching all content:', error);
                        // }
                        // }}
                        onClick={() => {
                            setSelectedSubThemeId(null);
                            setSelectedSubThemeName(t("all"));
                            setActiveKeyTheme(null);
                            setSelectedParentTheme({ id: null, name: t("all") });
                            setSearchParams(prevParams => {
                                prevParams.set('topic_id', '');
                                return prevParams;
                            });
                            dispatch(fetchContentByCategoryAction({ categoryId: id }));
                            }}
                        style={{
                        height: 'auto',
                        padding: '12px 16px',
                        justifyContent: 'flex-start',
                        marginBottom: '8px',
                        background: selectedParentTheme?.id === null ? 'rgb(231, 250, 255)' : 'none',
                        }}
                    >
                        <Col span={24} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <MyText
                            color={selectedParentTheme?.id === null ? 'rgb(0, 141, 210)' : '#0A033C'}
                            size={18}
                            weight={600}
                            style={{
                            lineHeight: '24px',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            }}
                        >
                            {t("all")}
                        </MyText>
                        </Col>
                    </ThemeButton>         
                    {parentThemes.map(parentTheme => (
                        <ThemeCollapse activeKey={activeKeyTheme} onChange={handlePanelChange} style={{ marginBottom: '8px', background: '#fff' }} key={parentTheme.id}>
                            <Panel
                                header={
                                    <MyText color="#0A033C" size={18} weight={600} style={{lineHeight: '24px'}}>
                                        {parentTheme.name}
                                    </MyText>
                                }
                                key={parentTheme.id}
                            >
                                <div style={{ marginBottom: '8px' }}>
                                    {themes.filter(theme => theme.parent_id === parentTheme.id).length === 0 ? (
                                        <MyText color="#0A033C" size={18} weight={400}>
                                            Уроков пока нет
                                        </MyText>
                                    ) : (
                                        <ul style={{ padding: 0, listStyleType: 'none' }}>
                                        {themes.filter(theme => theme.parent_id === parentTheme.id).map(subTheme => (
                                            <li
                                                key={subTheme.id}
                                                style={{ marginBottom: '8px', cursor: 'pointer', fontSize: '18px', color: selectedSubThemeId === subTheme.id ? 'rgba(0, 141, 210, 1)' : 'rgba(35, 38, 42, 1)', }}
                                                // onClick={async () => {
                                                //     setSelectedSubThemeId(subTheme.id);
                                                //     setSelectedSubThemeName(subTheme.name);
                                                //     setSelectedParentTheme(null);
                                                //     setSearchParams(prevParams => {
                                                //         prevParams.set('topic_id', subTheme.id);
                                                //         return prevParams;
                                                //     });
                                                //     try {
                                                //         const response = await fetchContentByCategory(id, subTheme.id);
                                                //         setThemes(response.themes);
                                                //         setLessons(response.content);
                                                //     } catch (error) {
                                                //         console.error('Error fetching content by topic:', error);
                                                //     }
                                                // }}
                                                onClick={() => {
                                                    setSelectedSubThemeId(subTheme.id);
                                                    setSelectedSubThemeName(subTheme.name);
                                                    setSelectedParentTheme(null);
                                                    setSearchParams(prevParams => {
                                                        prevParams.set('topic_id', subTheme.id);
                                                        return prevParams;
                                                    });
                                                    dispatch(fetchContentByCategoryAction({ categoryId: id, topicId: subTheme.id }));
                                                    }}
                                            >
                                                {subTheme.name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </Panel>
                    </ThemeCollapse>
                ))}
                {parentThemesButton.map(parentTheme => (
                    <ThemeButton key={parentTheme.id} 
                    //     onClick={async () => {
                    //     setSelectedSubThemeId(parentTheme.id);
                    //     setSelectedSubThemeName(parentTheme.name);
                    //     setActiveKeyTheme(null);
                    //     setSelectedParentTheme(parentTheme);
                    //     setSearchParams(prevParams => {
                    //         prevParams.set('topic_id', parentTheme.id);
                    //         return prevParams;
                    //     });
                    //     try {
                    //         const response = await fetchContentByCategory(id, parentTheme.id);
                    //         setThemes(response.themes);
                    //         setLessons(response.content);
                    //     } catch (error) {
                    //         console.error('Error fetching content by topic:', error);
                    //     }
                    // }} 
                    onClick={() => {
                        setSelectedSubThemeId(parentTheme.id);
                        setSelectedSubThemeName(parentTheme.name);
                        setActiveKeyTheme(null);
                        setSelectedParentTheme(parentTheme);
                        setSearchParams(prevParams => {
                            prevParams.set('topic_id', parentTheme.id);
                            return prevParams;
                        });
                        dispatch(fetchContentByCategoryAction({ categoryId: id, topicId: parentTheme.id }));
                    }}
                    style={{height: "auto",padding: '12px 16px', justifyContent: 'flex-start',marginBottom: '8px', background: selectedParentTheme?.id === parentTheme.id ? 'rgb(231, 250, 255)' : "none" }}>
                        <Col span={24} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <MyText
                            color={selectedParentTheme?.id === parentTheme.id ? 'rgb(0, 141, 210)' : '#0A033C'}
                            size={18}
                            weight={600}
                            style={{
                                lineHeight: '24px',
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word',
                            }}
                            >
                            {parentTheme.name}
                            </MyText>
                        </Col>
                    </ThemeButton>
                    ))}
            </PageName>
        </Card>
                            )}
            </div>
            {gameCategoriesState?.data?.length > 0 && (

            <Card style={{marginTop: '30px', borderRadius: '20px'}}>
                <MyText color='rgba(19, 15, 38, 1)' size={32} weight={800}
                        style={{fontFamily: 'Nunito', display: 'block', marginBottom: 32}}>
                  {t("games")}
                </MyText>
                <Spin spinning={gameCategoriesState?.loading}>
                    <Row gutter={[24,24]}>
                        {gameCategoriesState?.data && gameCategoriesState?.data?.map((gameCategory: any, index: any) => (
                          <Col
                            key={gameCategory.id + "-game-category"}
                            xs={24}
                            sm={12}
                            md={8}
                            lg={8}
                            xl={8}
                            xxl={6}
                          >
                              <Card hoverable bordered={false} onClick={() => handleSelectGameCategory(gameCategory)} style={{
                                  borderRadius: 24
                              }} styles={{
                                  body: {
                                      border: `1px solid ${colors[index].borderColor}`,
                                      backgroundColor: colors[index].backgroundColor,
                                      borderRadius: 24
                                  }
                              }}>
                                  <Col>
                                      <MyText style={{fontFamily: "Nunito"}} color={colors[index].textColor} weight={700} size={40} lineHeight="56px">{gameCategory.count}</MyText>
                                  </Col>
                                  <Col>
                                      <MyText style={{fontFamily: "Nunito"}} weight={500} size={20} lineHeight="32px">{gameCategory.name}</MyText>
                                  </Col>
                              </Card>
                          </Col>
                        ))}
                    </Row>
                </Spin>
            </Card>
            )}
        </Col>
    );
};
